module.exports = __webpack_public_path__ + "img/UHF-DVS-50.ed60725b.webp";